import type { LinesMap } from "../types/roof";
import type { BaseProduct } from "../types";

const getRidgeAndHipRolls = (
  lines: LinesMap,
  ridgeAndHipRoll?: BaseProduct
): number => {
  if (!ridgeAndHipRoll) {
    return 0;
  }

  const totalRidgeLengthCm = lines.ridge.reduce(
    (sum, line) => sum + line.length,
    0
  );
  const totalHipLengthCm = lines.hip.reduce(
    (sum, line) => sum + line.length,
    0
  );
  const combinedLineTotalCm = totalRidgeLengthCm + totalHipLengthCm;

  if (!combinedLineTotalCm) {
    return 0;
  }

  // Default fallback is set to 100cm (1 meter) if not specified in PIM specs
  const productRollLengthCm = ridgeAndHipRoll.coverLength || 100;

  // Formula: (Total cm / Roll cm) -> round up fractions -> add 1 extra unit safety buffer
  return Math.ceil(combinedLineTotalCm / productRollLengthCm) + 1;
};

export default getRidgeAndHipRolls;
